import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';
import { useVitrine } from '../hooks/useVitrine';
import { formatVitrineHours } from '../constants/vitrineDefaults';

const Footer = () => {
  const vitrine = useVitrine();

  return (
    <footer className="bg-stone-900 text-stone-400" data-testid="footer">
      <div className="max-w-7xl mx-auto py-16 px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h3 className="text-white text-2xl mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            <img src="/logo-taverne.png" alt="La Taverne" className="h-16" />
          </h3>
          <p className="text-sm leading-relaxed" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {vitrine.about_text1}
          </p>
        </div>
        <div>
          <h4 className="text-white text-xs uppercase tracking-[0.2em] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Informations</h4>
          <div className="space-y-3 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
            <div className="flex items-start gap-2"><MapPin size={14} className="mt-0.5 shrink-0 text-red-400" /><span>{vitrine.address}</span></div>
            <div className="flex items-start gap-2"><Phone size={14} className="mt-0.5 shrink-0 text-red-400" /><span>{vitrine.phone}</span></div>
            <div className="flex items-start gap-2"><Clock size={14} className="mt-0.5 shrink-0 text-red-400" /><span>{formatVitrineHours(vitrine)}</span></div>
          </div>
        </div>
        <div>
          <h4 className="text-white text-xs uppercase tracking-[0.2em] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Navigation</h4>
          <div className="flex flex-col space-y-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {[{ to: '/', label: 'Accueil' }, { to: '/menu', label: 'Notre Carte' }, { to: '/boissons', label: 'Boissons' }, { to: '/contact', label: 'Contact' }].map(link => (
              <Link key={link.to} to={link.to} className="text-sm text-stone-400 hover:text-white transition-colors">{link.label}</Link>
            ))}
          </div>
          <h4 className="text-white text-xs uppercase tracking-[0.2em] mb-3 mt-6" style={{ fontFamily: "'Outfit', sans-serif" }}>Legal / App Store</h4>
          <div className="flex flex-col space-y-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            <Link to="/privacy" className="text-sm text-stone-400 hover:text-white transition-colors">Privacy Policy (EN)</Link>
            <Link to="/contact-anglais" className="text-sm text-stone-400 hover:text-white transition-colors">Contact (EN)</Link>
            <Link to="/menu-anglais" className="text-sm text-stone-400 hover:text-white transition-colors">Menu (EN)</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-stone-800 py-6 text-center">
        <p className="text-xs text-stone-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
          &copy; {new Date().getFullYear()} La Taverne &mdash; Tous droits reserves
        </p>
      </div>
    </footer>
  );
};

export default Footer;
